import { Injectable } from '@angular/core';
import { HttpContext } from '@angular/common/http';

import { HttpService } from '@/app/core/services/http';

import { CredentialsInfo } from './auth.types';

import { ALLOW_REFRESH } from '@/app/core/interceptors';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private http: HttpService) {}

  login(email: string, password: string) {
    return this.http.post<CredentialsInfo>(
      'auth/login',
      { email, password },
      { context: new HttpContext().set(ALLOW_REFRESH, false) },
    );
  }

  logout() {
    return this.http.post('auth/logout', null, {
      skipHandleError: true,
    });
  }

  refreshToken() {
    return this.http.post<CredentialsInfo>('auth/refresh', null, {
      context: new HttpContext().set(ALLOW_REFRESH, false),
      skipHandleError: true,
    });
  }
}
